<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">RAF’s Centenary Flypast</h1>
<p class="title1">The Story Behind the Event that Marked 100 Years of the Royal Air Force</p>
<p class="author">Wing Commander Kevin Gatland OBE, MA, RAF</p>
<p class="author1">Foreword by Air Chief Marshal Sir Stephen Hillier GCB, CBE, DFC, MA, RAF</p>
<div class="img_container1p">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?a82c299c